var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHolaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.92,
    height: 26.815,
    viewBox: "0 0 38.92 26.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554",
    transform: "translate(-33 -62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6851",
    "data-name": "Path 6851",
    d: "M25.358,0h0A10.824,10.824,0,0,0,17.1,3.825l11.881,8.912a2.412,2.412,0,0,1,.957,1.964V16.06a10.739,10.739,0,0,1-2.517,6.9l4.43,3.323a2.648,2.648,0,0,0,4.229-2.115V10.719A10.7,10.7,0,0,0,25.358,0Z",
    transform: "translate(24.509 62.01)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M6.142,12.073V10.713a10.739,10.739,0,0,1,2.517-6.9L4.229.528A2.623,2.623,0,0,0,0,2.593V16.035A10.7,10.7,0,0,0,10.724,26.759h0a10.9,10.9,0,0,0,8.257-3.826L7.1,14.021a2.482,2.482,0,0,1-.957-1.948Z",
    transform: "translate(33 62.021)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    d: "M27.456,18.465A2.558,2.558,0,0,0,26.5,16.5L14.617,7.59a10.739,10.739,0,0,0-2.517,6.9v1.364a2.558,2.558,0,0,0,.957,1.964l11.882,8.911a10.739,10.739,0,0,0,2.517-6.9Z",
    transform: "translate(26.993 58.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6854",
    "data-name": "Path 6854",
    d: "M50.414,0A10.694,10.694,0,0,0,44.75,1.616a10.678,10.678,0,0,1,5.035,9.1V24.166a2.864,2.864,0,0,1-.055.5,11.665,11.665,0,0,0,3.8-.926l3.358,2.517a2.648,2.648,0,0,0,4.254-2.094V10.719A10.7,10.7,0,0,0,50.414,0Z",
    transform: "translate(10.781 62.01)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolaLogo);
export default __webpack_public_path__ + "static/media/hola-logo.6e19c585.svg";
export { ForwardRef as ReactComponent };